import type { GetProp, UploadProps } from "antd";
import { message, Upload } from "antd";
import { FormattedMessage, useIntl } from "react-intl";

import "./ImageUploader.scss";

const allowedFileTypes = ["image/png", "image/jpeg"];

type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];
type Props = {
  handleDrop: (file: FileType) => void;
  disabled: boolean;
};

const ImageUploader = ({ handleDrop, disabled }: Props) => {
  const [messageApi, messagesContextHolder] = message.useMessage();
  const { formatMessage } = useIntl();

  const onBeforeUpload = (file: FileType) => {
    if (!allowedFileTypes.includes(file?.type)) {
      messageApi.error(formatMessage({ id: "image.upload.type.invalid.error" }));
    } else {
      handleDrop(file);
    }
    return false;
  };

  return (
    <>
      {messagesContextHolder}
      <Upload.Dragger
        disabled={disabled}
        className="dropzone"
        maxCount={1}
        accept={allowedFileTypes.join(",")}
        showUploadList={false}
        beforeUpload={onBeforeUpload}
      >
        <FormattedMessage id="image.upload.help" />
      </Upload.Dragger>
    </>
  );
};

export default ImageUploader;
